var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', [_c('sub-visual', {
    attrs: {
      "sh": "Contact",
      "tabActive": "Direction",
      "bg": "/images/sub/visual/sv1.png"
    }
  }), _c('section', {
    staticClass: "sub-section--first sub-section--last"
  }, [_c('v-container', [_c('h2', {
    staticClass: "page-tit mb-lg-42"
  }, [_vm._v(" Direction ")]), _c('iframe', {
    staticClass: "mb-12 mb-lg-24",
    staticStyle: {
      "border": "0"
    },
    attrs: {
      "src": "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3171.3643506994827!2d127.21304991564394!3d37.35755484382564!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x357b55ff1de75c53%3A0xf6c56394bc1ebfcf!2s673-10%20Opo-ro%2C%20Opo-eup%2C%20Gwangju-si%2C%20Gyeonggi-do!5e0!3m2!1sen!2skr!4v1665478598219!5m2!1sen!2skr",
      "width": "100%",
      "height": "400",
      "allowfullscreen": "",
      "loading": "lazy",
      "referrerpolicy": "no-referrer-when-downgrade"
    }
  }), _c('h3', {
    staticClass: "tit mb-12 mb-lg-24 font-weight-semibold pl-10 pl-lg-38"
  }, [_vm._v(" Head Office ")]), _c('div', {
    staticClass: "w-100 border-top border-color-point border-lg-2 page-text"
  }, [_c('div', {
    staticClass: "d-flex align-center px-10 px-lg-38 py-10 py-lg-14 border-bottom"
  }, [_c('p', {
    staticClass: "w-80px w-lg-120px d-flex align-center justify-center text-center color-point border border-color-point font-weight-semibold mr-12 mr-lg-20 h-30px px-8 px-lg-14"
  }, [_vm._v(" Address ")]), _c('p', {
    staticClass: "color-grey-51"
  }, [_vm._v(" 673-10, Oppo-ro, Opo-Eup, Gwangju-si, Gyeonggi-Do, Korea 464-909 ")])]), _c('div', {
    staticClass: "d-flex align-center px-10 px-lg-38 py-10 py-lg-14 border-bottom"
  }, [_c('p', {
    staticClass: "w-80px w-lg-120px d-flex align-center justify-center text-center color-point border border-color-point font-weight-semibold mr-12 mr-lg-20 h-30px px-8 px-lg-14"
  }, [_vm._v(" Tel ")]), _c('p', {
    staticClass: "color-grey-51"
  }, [_vm._v(" +82-31-765-2268 ")])]), _c('div', {
    staticClass: "d-flex align-center px-10 px-lg-38 py-10 py-lg-14 border-bottom"
  }, [_c('p', {
    staticClass: "w-80px w-lg-120px d-flex align-center justify-center text-center color-point border border-color-point font-weight-semibold mr-12 mr-lg-20 h-30px px-8 px-lg-14"
  }, [_vm._v(" FAX ")]), _c('p', {
    staticClass: "color-grey-51"
  }, [_vm._v(" +82-31-765-2389 ")])]), _c('div', {
    staticClass: "d-flex align-center px-10 px-lg-38 py-10 py-lg-14 border-bottom"
  }, [_c('p', {
    staticClass: "w-80px w-lg-120px d-flex align-center justify-center text-center color-point border border-color-point font-weight-semibold mr-12 mr-lg-20 h-30px px-8 px-lg-14"
  }, [_vm._v(" E-MAIL ")]), _c('p', {
    staticClass: "color-grey-51"
  }, [_vm._v(" ist@ist-co.kr ")])])])])], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }